import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["navigation", "sidebarNavigation"];

  connect() {
    this.originalNodes = Array.from(this.navigationTarget.childNodes);

    this.mediaQueryList = window.matchMedia("(min-width: 992px)");
    this.handleMediaQueryChange = this.update.bind(this);
    this.mediaQueryList.addEventListener("change", this.handleMediaQueryChange);

    this.update();
  }

  disconnect() {
    if (this.mediaQueryList && this.handleMediaQueryChange) {
      this.mediaQueryList.removeEventListener("change", this.handleMediaQueryChange);
    }

    this.restoreOriginal();
  }

  update() {
    const isDesktop = this.mediaQueryList.matches;
    const hasSidebar = this.hasSidebarNavigationTarget;

    if (!isDesktop && hasSidebar) {
      this.moveChildren(this.navigationTarget, this.sidebarNavigationTarget);
    } else {
      this.restoreOriginal();
    }
  }

  moveChildren(fromContainer, toContainer) {
    while (fromContainer.firstChild) {
      toContainer.appendChild(fromContainer.firstChild);
    }
  }

  restoreOriginal() {
    if (!this.originalNodes) return;

    for (const node of this.originalNodes) {
      if (!this.navigationTarget.contains(node)) {
        this.navigationTarget.appendChild(node);
      }
    }
  }
}
